import { LINK, SUBMENU_OPENER } from '../constants';

import { DomWorker } from './DomWorker';

export class Navigation {
	constructor(content) {
		this.content = content;
	}

	getNavContainer() {
		const nav = document.createElement('nav');
		nav.innerHTML = '<ul></ul>';
		return nav;
	}

	async getNavListItems() {
		const mapItemsToElements = async (item) => {
			const { name, type, submenu, event } = item;
			const menuItem = document.createElement('li');
			if (type === LINK) {
				const linkElement = await DomWorker.getLink(item);
				menuItem.appendChild(linkElement);
			} else if (type === SUBMENU_OPENER) {
				const submenusList = await Promise.all(
					submenu.map(mapItemsToElements)
				).then((items) => items);

				const submenus = submenusList.map((e) => e.outerHTML).join('');
				menuItem.className = 'subMenuOpener';
				menuItem.innerHTML = `<span title="${name}">${name}</span><ul class="submenu">${submenus}</ul>`;

				if (event) {
					const { eventType, eventParams, callBack } = event;
					menuItem
						.querySelector(`a[title="${name}"], span[title="${name}"]`)
						.addEventListener(eventType, callBack, eventParams);
				}
			}
			return menuItem;
		};

		const eventTypes = ['click', 'scroll', 'touchmove', 'mouseleave'];
		for (const eventType of eventTypes) {
			document.addEventListener(
				eventType,
				(event) => {
					if (
						event.type === 'click' &&
						(event.target.classList.contains('subMenuOpen') ||
							event.target.closest('.subMenuOpener'))
					)
						return;
					const subMenuOpen = document.querySelector('.subMenuOpen');
					if (subMenuOpen) subMenuOpen.classList.remove('subMenuOpen');
				},
				{ passive: true }
			);
		}

		const navigationContent = await Promise.all(
			this.content.map(mapItemsToElements)
		).then((items) => items);

		return navigationContent;
	}

	async getNavigation() {
		const navContainer = this.getNavContainer();
		const navItems = await this.getNavListItems();
		for (const item of navItems) {
			navContainer.querySelector('ul').appendChild(item);
		}
		return navContainer;
	}
}
